export function getAssetsBlocks(strMeter) {
  const result = {
    name: '',
    cssClass: ['general-block'],
    margin: 0,
    value: 0,
    children: [],
  };
  strMeter.listCurrencies.forEach((currency) => {
    const currencyChild = {
      name: currency,
      cssClass: ['currency-block'],
      margin: 5,
      value: 0,
      fillPopup: true,
      children: [],
    };
    result.children.push(currencyChild);
    strMeter.listCurrencies.forEach((currency2) => {
      if (currency != currency2) {
        const pairChild = {
          name: `${currency}/${currency2}`,
          cssClass: ['pair-block'],
          margin: 0,
          value: 0,
          sortPopup: true,
          children: [],
        };
        currencyChild.children.push(pairChild);
        strMeter.timeFrames.forEach((timeFrame) => {
          const pairChange = strMeter.strengthCalculator.getPairChange(
            currency,
            currency2,
            timeFrame
          );
          const pairRate = strMeter.strengthCalculator.getPairRate(
            currency,
            currency2
          );
          const cssClass = getCssClass(pairChange);
          const tfChild = {
            name: '',
            margin: 1,
            cssClass: [cssClass],
            value: pairChange,
            children: [],
            cssClassWrapper: ['name-corner'],
            sortPopup: true,
            pairName: `${currency}/${currency2}`,
            timeFrame: timeFrame,
            pairRate: pairRate,
          };
          pairChild.children.push(tfChild);
        });
      }
    });
  });
  return result;
}

function getCssClass(pairChange) {
  if (pairChange < 0) {
    return 'negative';
  } else if (pairChange == 0) {
    return 'flat';
  } else {
    return 'positive';
  }
}
